import React from 'react';

import Modal from '../../../Modal';
import CourseFilterList from '../CourseFilterList';
import { TNamedItem } from '../../../../../types';
import {
  filterCourses,
  setActiveFilterType,
} from '../../../../../store/reducers/librarySlice';
import { useAppDispatch, useAppSelector } from '../../../../../hooks/hooks';

interface ICourseFilterModal {
  onClose: () => void;
}

const CourseFilterModal: React.FC<ICourseFilterModal> = ({ onClose }) => {
  const dispatch = useAppDispatch();
  const {
    activeFilters,
    secondaryFilters = [],
    stackFilters = [],
    activeFilterType,
  } = useAppSelector((state) => state.libraryReducer);

  const handleFilterSelect = (secondaryFilter: TNamedItem | null) => {
    dispatch(filterCourses({ secondaryFilter }));
    onClose();
  };

  const handleFilterTypeChange = (type: 'categories' | 'stacks') => {
    dispatch(setActiveFilterType(type));
    // Clear the active filter when switching between filter types
    if (activeFilters.secondaryFilter) {
      dispatch(filterCourses({ secondaryFilter: null }));
    }
  };

  return (
    <Modal title="Filter by" onClose={() => onClose()}>
      <div className="flex flex-col gap-4">
        <div className="flex flex-col gap-2">
          <div className="flex flex-col gap-2">
            <div
              className={`px-2 py-1 rounded cursor-pointer ${
                activeFilterType === 'categories'
                  ? 'bg-blue-100 text-blue-primary hover:bg-blue-100'
                  : 'hover:bg-gray-200'
              }`}
              onClick={() => handleFilterTypeChange('categories')}
            >
              Categories
            </div>
            <div
              className={`px-2 py-1 rounded cursor-pointer ${
                activeFilterType === 'stacks'
                  ? 'bg-blue-100 text-blue-primary hover:bg-blue-100'
                  : 'hover:bg-gray-200'
              }`}
              onClick={() => handleFilterTypeChange('stacks')}
            >
              Stacks
            </div>
          </div>
        </div>

        <div className="mt-2">
          <div className="mb-2 font-bold">
            {activeFilterType === 'categories' ? 'Categories' : 'Stacks'}
          </div>
          <CourseFilterList
            filters={
              activeFilterType === 'categories'
                ? secondaryFilters
                : stackFilters
            }
            active={activeFilters.secondaryFilter}
            setActive={handleFilterSelect}
          />
        </div>
      </div>
    </Modal>
  );
};

export default CourseFilterModal;
